import { Validity } from '@front-core/form-field';
export const isInvalidField = (hasError) => hasError ? Validity.invalid : undefined;
